import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './context/LanguageContext';
import SmoothScroll from './components/SmoothScroll';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import QuoteRequest from './pages/QuoteRequest';
import './App.css';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/chi-siamo" element={<About />} />
                <Route path="/servizi" element={<Services />} />
                <Route path="/services" element={<Services />} />
                <Route path="/risorse" element={<Resources />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/contatti" element={<Contact />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/preventivo" element={<QuoteRequest />} />
                <Route path="/quote" element={<QuoteRequest />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppButton />
          </SmoothScroll>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
